interface CollaboratorRemoveData {
    buildHubId: string;
    collaboratorId: string;
}

/**
 * Builds FormData for removing a collaborator from BuildHub.
 */
export function buildFormDataForCollaboratorRemove(
    data: CollaboratorRemoveData
): FormData {
    const formData = new FormData();
    formData.append('buildHubId', data.buildHubId);
    formData.append('collaboratorId', data.collaboratorId);

    return formData;
}
